// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { z } from 'zod';

export const financialKnowledgeSchema = z.object({
  q_education_level: z.enum([
    'secondary_education',
    'higher_education',
    'finance_education',
    'other_education',
  ]),
  q_financial_experience: z.enum([
    'no_finance_exp',
    'occasional_finance_exp',
    'direct_finance_exp',
  ]),
  q_financial_knowledge: z.enum([
    'basic_knowledge',
    'basic_concepts',
    'intermediate_concepts',
    'advanced_concepts',
  ]),
  q_stocks_knowledge: z.enum([
    'value_not_market_price',
    'dividend_only_return',
    'secondary_market_trading',
    'dont_know_stocks',
  ]),
  q_fund_rating_knowledge: z.enum([
    'fund_risk_level',
    'fund_return_potential',
    'fund_knowledge_req',
    'dont_know_fund_rating',
  ]),
  q_pe_funds_knowledge: z.enum([
    'private_equity_invest',
    'highly_liquid_funds',
    'min_investment_amount',
    'dont_know_pe_funds',
  ]),
  q_etf_knowledge: z.enum([
    'index_replication',
    'not_collective_invest',
    'no_loss_diversification',
    'dont_know_etf',
  ]),
  q_credit_risk_knowledge: z.enum([
    'dont_know_credit_risk',
    'default_payment_risk',
    'currency_price_risk',
  ]),
  q_liquidity_risk_knowledge: z.enum([
    'dont_know_liquidity_risk',
    'access_limitation_risk',
    'currency_value_risk',
  ]),
  q_market_risk_knowledge: z.enum([
    'dont_know_market_risk',
    'asset_price_volatility',
    'interest_rate_fluctuation',
  ]),
  q_currency_risk_knowledge: z.enum([
    'dont_know_currency_risk',
    'exchange_rate_variation',
    'volatility_fluctuation',
  ]),
});

export type FinancialKnowledgeFormData = z.infer<typeof financialKnowledgeSchema>;
